/**
 * @format
 *
 */

import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import Loading from '../../../Shared/Components/Loading';
import Pagination from '../../../Shared/Components/Pagination';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { matchGenderLabel } from '../../../Shared/utils/helper';
import { useAccess } from '../../../Shared/hooks/useAccess';
import { competitionLevelCase } from '../../../Shared/utils/helper';
import Master from '../../Layouts/Master';

const Match = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const { canManageMatches } = useAccess();
  const [, setMatchStyleRemoveId] = useState();
  const [, setModalIsOpen] = useState(false);

  useEffect(() => {
    getMatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  const getMatch = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/match${search || ''}`,
      {},
      (res) => {
        eventContext.matches = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  // const removeMatch = async (matchId) => {
  // 	setRemoveLoading(true);

  // 	await useApi.delete(
  // 		`/panel/match/${matchId}`,
  // 		{},
  // 		(res) => {
  // 			success('مسابقه مورد نظر با موفقیت حذف شد');
  // 			setRemoveLoading(false);
  // 			setModalIsOpen(false);
  // 			getMatch();
  // 		},
  // 		(err) => {
  // 			setRemoveLoading(false);
  // 			setLoading(false);
  // 			error('حذف به علت خطا انجام نشد');
  // 		},
  // 	);
  // };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست مسابقه
          </h1>
        </div>
        {canManageMatches() && (
          <Link
            to='/panel/matches/create'
            className='d-flex flex-row btn btn-outline-info '
          >
            <i className='fad fa-plus f-16 mx-2'></i>
            <span className='f-13'>ایجاد مسابقه</span>
          </Link>
        )}
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.matches?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>سبک مسابقه</th>
                <th>شروع برگزاری</th>
                <th>پایان برگزاری</th>
                <th>سطح برگزاری</th>
                <th>جنسیت</th>
                <th>استان محل برگزاری</th>
                <th>شهر محل برگزاری</th>
                <th>وضعیت</th>
                {canManageMatches() && (
                  <th>ثبت نام شرکت کنندگان</th>
                )}
                <th>لیست ثبت نام</th>
                {canManageMatches() && <th>عملیات</th>}
              </tr>
            </thead>
            <tbody>
              {eventContext.matches?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.title}</td>
                  <td>{item.match_style?.title}</td>
                  <td>
                    {moment(item.start ?? '1990-01-01', 'YYYY-MM-DD')
                      .locale('fa')
                      .format('YYYY/MM/DD')}
                  </td>
                  <td>
                    {moment(item.end ?? '1990-01-01', 'YYYY-MM-DD')
                      .locale('fa')
                      .format('YYYY/MM/DD')}
                  </td>
                  <td>
                    {competitionLevelCase(item?.match_style?.competition_level)}
                  </td>
                  <td>{matchGenderLabel(item?.gender)}</td>
                  <td>{item?.province?.name}</td>
                  <td>{item?.city?.name}</td>
                  <td>
                    <span
                      className={`badge badge-${
                        item.status?.id === 1
                          ? 'warning'
                          : item.status?.id === 2
                          ? 'primary'
                          : item.status?.id === 3
                          ? 'danger'
                          : item.status?.id === 4
                          ? 'success'
                          : ''
                      } badge-pill p-2`}
                    >
                      {item.status?.id === 1
                        ? 'در حال انتظار'
                        : item.status?.id === 2
                        ? 'تایید شده'
                        : item.status?.id === 3
                        ? 'لغو شده'
                        : item.status?.id === 4
                        ? 'برگزار شده'
                        : ''}
                    </span>
                  </td>
                  {canManageMatches() && (
                    <td>
                      <Link
                        to={`/panel/matches/${item.id}/register-match`}
                        className='mx-2'
                      >
                        ثبت نام
                      </Link>
                    </td>
                  )}

                <td>
                    <Link
                        to={`/panel/matches/${item.id}/register-list`}
                        className='mx-2 text-nowrap'
                    >
                        لیست ثبت نام
                    </Link>
                </td>

                  {canManageMatches() && (
                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          to={`/panel/matches/${item.id}`}
                          className='mx-2'
                        >
                          مشاهده
                        </Link>
                        <Link
                          to={`/panel/matches/edit/${item.id}`}
                          className='mx-2'
                        >
                          ویرایش
                        </Link>
                        <Link
                          to='#'
                          className='mx-2'
                          onClick={(e) => {
                            e.preventDefault();
                            setMatchStyleRemoveId(item.id);
                            setModalIsOpen(true);
                          }}
                        >
                          حذف
                        </Link>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد مسابقه بر روی منوی ایجاد مسابقه کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={eventContext.matches?.meta?.pagination?.total_pages}
          basePath='/panel/matches/lists'
        />
      </div>
    </Master>
  );
};

export default Match;
